import { useEffect, useState } from "react";
import { useCurrentUser, useCentralApi } from "hooks/shared";
import useTaskContext from "./useTaskContext";

export interface TaskProblemLogUpdateData {
    problemLogId?: number;
    description?: string;
    resolution: boolean;
}

const useTaskProblemUpdater: (problem: TaskProblemLogUpdateData | undefined) => any = (problem) => {
    const [ result, setResult ] = useState<any>();
    const [ error, setError ] = useState<string | null>(null);
    const [ loading, setLoading ] = useState<boolean>(false);    
    const user = useCurrentUser();
    const taskContext = useTaskContext();
    const { task } = taskContext;
    const fetcher = useCentralApi(user);

    useEffect(() => {        
        const controller = new AbortController();
        const fetchTasks = async () => {
            if (user && user.id_token && problem && (problem.description || problem.problemLogId)) {
                setLoading(true);
                try {
                    const resp = await fetcher(`/api/v3/tasks/${task?.id}/problemdetails${!problem.description ? '/remove' : ''}`, {
                        method: 'PUT',
                        body: JSON.stringify(problem)
                    });

                    if (!resp.ok) {
                        // RESPOND TO ERRORS
                    }

                    const data = await resp.json();
                    setResult(data);
                    // setHasViewProblemLogPrivileges(data.hasViewProblemLogPrivileges);

                } catch (err) {
                    // Will be done in BFLY-8658 or BFLY-9022
                    setError('Error updating problem log');
                } finally {
                    if (!controller.signal.aborted)
                        setLoading(false);
                }
            }
        };
        
        fetchTasks();
        return () => controller.abort();
    }, [user, problem ]);

    return [
        result,
        loading,
        error
    ];
};

export default useTaskProblemUpdater;